var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasNodes
        ? [_c("RecursiveTreeGroupedLinks", { attrs: { nodes: _vm.nodes } })]
        : _vm.showEmptyMessage
        ? [
            _c(
              "div",
              {
                staticClass: "text-center alert",
                class: _vm.classEmptyMessage,
                attrs: { role: "alert" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t(_vm.emptyMessage)) +
                    "\n        "
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }